var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.7877 15.7715C15.8572 15.1887 16.5 14.4402 16.5 13.625C16.5 12.761 15.7778 11.972 14.5905 11.375C13.2173 10.685 11.2215 10.25 9 10.25C6.7785 10.25 4.78275 10.685 3.4095 11.375C2.22225 11.972 1.5 12.761 1.5 13.625C1.5 14.489 2.22225 15.278 3.4095 15.875C4.78275 16.565 6.7785 17 9 17C11.3302 17 13.4115 16.5222 14.7877 15.7715Z",
    fill: "#780000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 6.88625C3.75 4.18775 6.1005 2 9 2C11.8995 2 14.25 4.18775 14.25 6.88625C14.25 9.56375 12.5745 12.6875 9.96 13.805C9.65631 13.9337 9.32984 14 9 14C8.67016 14 8.34369 13.9337 8.04 13.805C5.4255 12.6875 3.75 9.563 3.75 6.88625ZM9 8.75C9.39782 8.75 9.77936 8.59196 10.0607 8.31066C10.342 8.02936 10.5 7.64782 10.5 7.25C10.5 6.85218 10.342 6.47064 10.0607 6.18934C9.77936 5.90804 9.39782 5.75 9 5.75C8.60218 5.75 8.22064 5.90804 7.93934 6.18934C7.65804 6.47064 7.5 6.85218 7.5 7.25C7.5 7.64782 7.65804 8.02936 7.93934 8.31066C8.22064 8.59196 8.60218 8.75 9 8.75Z",
    fill: "#780000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f4ad89a2850a3d6143216665f2a8ea9c.svg";
export { ForwardRef as ReactComponent };